import { Link } from 'react-router-dom'
import { ROUTE_META } from '../lib/site'
import { useDocumentTitle } from '../lib/useDocumentTitle'
import s from './NotFound.module.css'

export function NotFound() {
  const meta = ROUTE_META['/404']
  useDocumentTitle(meta.title, meta.description)

  return (
    <main className={s.page}>
      <p className={s.code} aria-hidden="true">
        404
      </p>
      <h1 className={s.title}>NOTHING LOGGED HERE.</h1>
      <p className={s.body}>This page doesn't exist — or it's asleep. Either way, don't wake it.</p>
      <Link className={s.cta} to="/">
        BACK TO HOME
      </Link>
    </main>
  )
}
